<template lang="html">
  <div>
    <vs-card v-if='campaign'>
      <div slot='header'>
        Progress
      </div>

      <vs-progress :height="12" :indeterminate='campaign.is_paused==0' :percent="percentage" color="success"></vs-progress>

      <template v-if='percentage<100'>
        <vs-button class='mt-3' v-if='campaign.is_paused==0' @click.prevent='togglePause()'>{{ $t('Pause') }}</vs-button>
        <vs-button class='mt-3' v-else @click.prevent='togglePause()'>{{ $t('Resume') }}</vs-button>
      </template>
      <vs-button v-if='showRetryAll' class='mt-3'  @click.prevent='retryAll()'>{{ $t('RetryAll') }}</vs-button>
    </vs-card>
    
    <vs-card v-if='campaign'>
      <vs-table search max-items="10" pagination :data="messages">
      
        <template slot="thead">
          <vs-th sort-key="user.id_number">{{ $t("IdNumber") }}</vs-th>
          <vs-th sort-key="user.first_name">{{ $t("FirstName") }}</vs-th>
          <vs-th sort-key="user.last_name">{{ $t("LastName") }}</vs-th>
          <vs-th v-if='campaign.type==1' sort-key="email">{{ $t("Email") }}</vs-th>
          <vs-th v-else-if='campaign.type==2' sort-key="phone">{{ $t("Phone") }}</vs-th>
          <vs-th sort-key="started_at">{{ $t("StartedAt") }}</vs-th>
          <vs-th sort-key="completed_at">{{ $t("CompletedAt") }}</vs-th>
          <vs-th sort-key="status">{{ $t("Status") }}</vs-th>
          <vs-th sort-key="system_remark">{{ $t("SystemRemark") }}</vs-th>
          <vs-th sort-key="last_read_at">{{ $t("LastReadAt") }}</vs-th>
          <vs-th>{{ $t("Action") }}</vs-th>
        </template>

        <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].user.id_number">
                <router-link :to="{name:'ViewUser', params: {id: data[indextr].user_id}}"> {{ data[indextr].user.id_number }} </router-link>
              </vs-td>
              <vs-td :data="data[indextr].user.first_name">
                {{ data[indextr].user.first_name }}
              </vs-td>
              <vs-td :data="data[indextr].user.last_name">
                {{ data[indextr].user.last_name }}
              </vs-td>
              <vs-td v-if='campaign.type==1' :data="data[indextr].email">
                <a :href="'mailto:'+data[indextr].email">{{ data[indextr].email }}</a>
              </vs-td>
              <vs-td v-else-if='campaign.type==2' :data="data[indextr].phone">
                {{ data[indextr].phone }}
              </vs-td>
              <vs-td :data="data[indextr].started_at">
                {{ data[indextr].started_at | displayDate }}
              </vs-td>
              <vs-td :data="data[indextr].completed_at">
                {{ data[indextr].completed_at | displayDate }}
              </vs-td>
              <vs-td :data="data[indextr].status">
                <span v-if="data[indextr].status=='RUNNING'">Running</span>
                <span v-else-if="data[indextr].status=='FAILED'" style="color: red">Failed</span>
                <span v-else-if="data[indextr].status=='SUCCESS'" style="color: green">Success</span>
                <span v-else-if="data[indextr].status=='PENDING'">Pending</span>
              </vs-td>
              <vs-td :data="data[indextr].system_remark">
                {{ data[indextr].system_remark }}
              </vs-td>
              <vs-td :data="data[indextr].last_read_at">
                {{ data[indextr].last_read_at | displayDate }}
              </vs-td>
              <vs-td :data="data[indextr].id">
                <router-link custom :to="{name: 'CampaignMessagePreview', params: {id: data[indextr].campaign_id, message_id: data[indextr].id}}" v-slot="{navigate}">
                  <vs-button class="mb-2 mr-1 run_btn" color="primary" type="filled" @click='navigate'>Preview</vs-button>
                </router-link>
                <vs-button v-if="data[indextr].status=='FAILED'" class="mb-2 mr-1" color="primary" type="filled" @click.prevent='retry(data[indextr])'>Retry</vs-button>
              </vs-td>
            </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import { get, togglePause, retry } from '@/api/campaign';

export default {
  data: () => ({
    campaign: null,
    messages: [],
    completed: 0
  }),
  computed: {
    percentage: function() {
      return (this.completed/this.total) * 100;
    },
    total: function() {
      return this.messages.length;
    },
    showRetryAll: function() {
      return this.messages.findIndex(message => message.status=='FAILED') > -1;
    }
  },
  created() {
    this.get()
  },
  beforeDestroy() {
    window.Echo.leave('private-campaign-id-'+this.$route.id);
  },
  methods: {
    async retry(message) {
      try{
        const res = await retry(this.$route.params.id, {message_ids: [message.id]});
        if(!(res.status==200 && res.data.status=='success'))
          throw res.statusText;
        message.status = 'PENDING';
        message.completed_at = null;
        message.system_remark = null;
        this.completed = res.data.data.completed;
      }catch(err){
        console.error(err);
      }
    },
    async retryAll() {
      try{
        const res = await retry(this.$route.params.id);
        if(!(res.status==200 && res.data.status=='success'))
          throw res.statusText;
        this.messages = this.messages.map(message => {
          if(message.status=='FAILED') {
            message.status = 'PENDING';
            message.completed_at = null;
            message.system_remark = null;
          }
          return message;
        });
        this.completed = res.data.data.completed;
      }catch(err){
        console.error(err);
      }
    },
    async togglePause() {
      try{
        const res = await togglePause(this.$route.params.id);
        if(!(res.status==200 && res.data.status=='success'))
          throw res.statusText;
        this.campaign.is_paused = res.data.data.is_paused;
      }catch(err){
        console.error(err);
      }
    },
    async get() {
      try{
        const res = await get(this.$route.params.id)
        if(!(res.status==200 && res.data.status=='success'))
          throw res.statusText;
        this.messages = res.data.data.messages;
        this.completed = res.data.data.completed;
        delete res.data.data.messages;
        delete res.data.data.completed;
        this.campaign = res.data.data;

        const me = this;
        window.Echo.private('campaign-id-'+this.campaign.id)
        .listen('CampaignStatusNotifier', response => {
          console.log('CampaignStatusNotifier', response);
          const message = me.messages.find(u => u.id==response.data.message_id);
          if(message) {
            message.status = response.data.status;
            message.started_at = response.data.started_at;
            message.completed_at = response.data.completed_at || null;
            message.system_remark = response.data.system_remark;

            if(response.data.completed)
              me.completed = response.data.completed
          }
        });
      }catch(err) {
        console.error(err);
      }
      
    }
  }
}
</script>

<style>

</style>